import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

type EgresoDialogProps = {
    open: boolean;
    onClose: () => void;
    onOnlyDispatch: () => void;
    onDispatchFinalize: () => void;
}
const EgresoDialog: React.FC<EgresoDialogProps> = ({
    open,
    onClose,
    onOnlyDispatch,
    onDispatchFinalize,
}) => {
  return(
    <Dialog
    open={open}
    onClose={onClose}
  >
    <DialogTitle >
      {'Confirmar'}
    </DialogTitle>
    <DialogContent>
      <DialogContentText>{'¿Deseas finalizar también la solicitud de pedido o solo deseas hacer la trasferencia?'}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button variant="outlined" onClick={onClose}>Cancelar</Button>
      <Button variant="outlined" onClick={onOnlyDispatch}>Solo Trasferencia</Button>
      <Button variant="outlined" onClick={onDispatchFinalize}>Trasferencia/Finalizar</Button>
    </DialogActions>
  </Dialog>
  )
}
export default EgresoDialog